import z from 'zod'
import { paxtonHighlightAreaSchema } from '@/components/react-pdf-viewer/schema/paxton-highlight-area'
import { MedChronSourceRefSchema } from '@/medical-chronology/sources/schemas'

export const MedChronReferenceSchema = z.object({
  id: z.string().uuid(),
  file_path: z.string(),
  source: MedChronSourceRefSchema,
  // Backend emits 1-based page numbers (PaxtonHighlightBlock.page_number is documented "Canonical
  // 1-based document page number"), but the shared viewer layer is 0-based: PageCitation renders
  // `page + 1` for its label and the PDF viewer's jumpToPage is 0-indexed. Convert to 0-based here
  // so the citation label reads the true page and click-to-source lands on it. See the matching
  // note in events/store/schemas.ts. (Navigation for references that carry `highlights` uses the
  // highlight pageIndex, which the backend already emits 0-based, so that path is unaffected here.)
  pages: z.array(z.number().int().nonnegative()).transform((pages) => pages.map((page) => page - 1)),
  highlights: z.array(paxtonHighlightAreaSchema),
})

export type MedChronReference = z.infer<typeof MedChronReferenceSchema>
